var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20545 16.5008C9.18145 16.5008 9.1582 16.5008 9.1342 16.5C7.0387 16.482 5.08195 15.642 3.6262 14.1353C0.86845 11.2815 0.7822 6.55878 3.4327 3.60753C4.25845 2.68728 5.26645 1.99503 6.4282 1.55028C6.70195 1.44378 7.0132 1.50978 7.22245 1.71678C7.4317 1.92303 7.50145 2.23278 7.4002 2.50878C6.5617 4.80003 7.1332 7.39203 8.85595 9.11178C10.5795 10.8315 13.1782 11.4023 15.4769 10.5653C15.7529 10.4633 16.0634 10.5353 16.2689 10.7438C16.4744 10.9545 16.5397 11.265 16.434 11.5388C16.041 12.561 15.4515 13.4685 14.682 14.2358C13.2172 15.6983 11.2747 16.5008 9.20545 16.5008Z",
    fill: "#BBC0D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.91ed53ab771ae2c1b9aa18809aafb2d1.svg";
export { ForwardRef as ReactComponent };